module.exports = __webpack_public_path__ + "img/IT0000076665305.f3ead666.png";